import React from 'react'
import './index.scss'
import clsx from 'clsx'
import { useFormContext, Controller } from 'react-hook-form'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import DatePicker from 'react-datepicker'
import FieldErrorSectionForm from '@App/kit/fields/v2/FieldErrorSectionForm'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import DatePickerFormFieldProps from '@App/forms/v2/common/date-picker-form-field'

const DatePickerForm = (props: DatePickerFormFieldProps) => {
    const { control } = useFormContext()

    const { helperTitle, helperText, label, maxDate = new Date('2100-12-31'), minDate = new Date('1900-01-01') } = props

    const inputName = getInputName(props)

    return (
        <Controller
            name={inputName}
            control={control}
            render={({ field: { value, onChange, onBlur, name }, fieldState }) => {
                const classNames = clsx(
                    'input-text-form-component',
                    'main-color-set',
                    'datepicker-form-component',
                    !!value && 'filled',
                    !!fieldState.error && 'error'
                )
                return (
                    <div className={classNames} data-testid={name}>
                        <label htmlFor={name}>{label}</label>
                        {!!helperTitle && !!helperText && <CustomToolTip title={helperTitle} info={helperText} />}
                        <DatePicker
                            name={name}
                            onChange={onChange}
                            selected={value}
                            onBlur={onBlur}
                            maxDate={maxDate}
                            minDate={minDate}
                            showPopperArrow={false}
                            dateFormat="MMMM d yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            isClearable
                        />
                        <FieldErrorSectionForm {...props} fieldError={fieldState.error} />
                    </div>
                )
            }}
        />
    )
}

export default DatePickerForm
